import React from 'react'
import { mobile } from './tokens'

interface MobileListGroupProps {
  children: React.ReactNode
  label?: string
  className?: string
}

/** Inset grouped list (settings-style / channel lists). */
export function MobileListGroup({ children, label, className = '' }: MobileListGroupProps) {
  return (
    <div className={className}>
      {label && <p className={`${mobile.sectionLabel} mb-1.5`}>{label}</p>}
      <div className={mobile.listGroup}>{children}</div>
    </div>
  )
}

interface MobileGroupRowProps {
  children: React.ReactNode
  onClick?: () => void
  className?: string
}

export function MobileGroupRow({ children, onClick, className = '' }: MobileGroupRowProps) {
  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={`${mobile.row} ${className}`.trim()}>
        {children}
      </button>
    )
  }
  return <div className={`${mobile.row} ${className}`.trim()}>{children}</div>
}
